import {
  CrmLayoutLogoComponent,
  CrmLayoutMenuComponent,
  CrmLayoutProfileComponent,
  crmLayoutSidebarOnly,
  CrmLayoutV2Config,
} from 'common-module/layout-v2';

import { LayoutProfileProvider } from '~/shared/crm/layout/layout-profile.provider';

export const layoutConfig: CrmLayoutV2Config = {
  siderLeft: {
    ...crmLayoutSidebarOnly.siderLeft,
    collapseDisabled: true,
    theme: 'dark',
    fragments: [
      { key: 'logo', content: CrmLayoutLogoComponent },
      { key: 'menu', content: CrmLayoutMenuComponent },
      {
        key: 'profile',
        content: CrmLayoutProfileComponent,
        provider: LayoutProfileProvider,
      },
    ],
  },
  logo: {
    smallLogoPath: '/assets/images/logo-main.png',
    defaultLogoPath: '/assets/images/logo-main.png',
  },
  menu: {
    items: [
      {
        routeKey: 'users',
        key: 'menu.users',
        icon: 'profile',
      },
    ],
  },
  profile: {
    dropdownPlacement: 'right',
    dropdownIcon: 'down',
    dropdownIconVisible: 'right',
  },
};
